import { gettext } from '@eventbrite/legacy-infra.i18n';
import React from 'react';
import { useErrorDisplayContext } from '../../context';
import { SubmissionError } from '../SubmissionError';
import styles from './ReportEventFormContent.module.scss';

export const ReportEventFormContent = (props: {
    children: React.ReactNode;
}) => {
    const { children } = props;
    const { error, setError } = useErrorDisplayContext();
    return (
        <div className={styles.formContainer}>
            <p className={styles.formDescription}>
                {gettext(
                    "Please help Eventbrite investigate this event by providing information about why you're reporting it.",
                )}
            </p>
            <SubmissionError
                hasError={error || false}
                onClose={() => setError?.(false)}
                data-testid="form-submission-error"
                containerClassName={`error-notification ${styles.errorContainer}`}
            >
                {gettext('There was an error submitting the report.')}
            </SubmissionError>
            {/* TODO: allow enter to trigger `handleSubmit` encapsulated in `ReportEventFormFields.tsx` */}
            <form
                onSubmit={(event) => {
                    event.preventDefault();
                }}
            >
                <p className={styles.formTitle}>
                    {gettext('Reason For Report')}
                </p>
                {children}
            </form>
        </div>
    );
};
